import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { ReturnNativeService } from "../../../../app/shared/service/comunicator-native/return-native/return-native";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { AnalyticsAdjustPageService } from '../../../shared/service/analytics-adjust-pages/analytics-adjust-page.service';
import { AnalyticsAdjustPagesModel } from '../../../shared/service/analytics-adjust-pages/analytics-adjust-pages-models';
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { DomainFactoryService } from "../../../shared/service/domains/domain-factory-service";
import { DomainDataType } from "../../../shared/service/domains/model/domain-data-type";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { LogService } from "../../../shared/service/log/log.service";
import { RadioModel } from "../../model/radio.model";
import { PersonalDataService } from "../../service/personal-data.service";

@Component({
  selector: "app-document-type",
  templateUrl: "./document-type.component.html",
  styleUrls: ["./document-type.component.scss"],
})
export class DocumentTypeComponent
  extends DefaultPageComponent
  implements OnInit
{
  headerId = "document-type";
  public selectedItem: string;
  selectedName = "";
  buttonEnable = false;
  public documentType = new Array<RadioModel>();
  textAria = "";
  idLabel = "page-document-type";
  titlePage = "Dados pessoais";
  showRetry = false;
  loading = true;
  documetValuesEdit: {
    documentType: string;
    documentTypeName: string;
    documentNumber: string;
  };
  data: any;
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  analyticsPageAdjust: AnalyticsAdjustPagesModel;
  sendAnalyticsFirstView = false;
  startStage = "";
  endStage = "";
  idLabelDocumentType = "labelDocumentType";
  idRadioDocumentType = "radioDocumentType";
  idRadioButtonDocumentType = "radioButtonDocumentType";
  idRetryDocumentType = "retryDocumentType";

  constructor(
    public router: NavController,
    private personalDataService: PersonalDataService,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public domainFactory: DomainFactoryService,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private logService: LogService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsAdjustPageService: AnalyticsAdjustPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);

    this.configureDomain(null, DomainDataType.DocumentType);

    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.getAnalyticsPageAdjust();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.getDomainType();
    this.setValueDocumentEdit();
    this.editFieldInvest("documento_codigo", "documentType", "personalData");
    this.getTrack();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = "personal-data";

    if (
      this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_PERSONAL
    ) {
      this.startStage = "2";
      this.endStage = "11";
    } else {
      this.startStage = "";
      this.endStage = "";
    }
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getAnalyticsPageAdjust() {
    this.analyticsPageAdjust = this.analyticsAdjustPageService.setAnalyticsPageAdjust();
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.documentType;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathTipoDocumento,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackAdjustLoadPage() {
    const paramDefautl = {
      it_token: this.analyticsPageAdjust.criarconta_dados_documento,
    }

    this.analyticsAdjustPageService.sendTrackAdjust(paramDefautl)
  }

  sendTrackGA4LoadPageError() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameAlert,
      custom_path: this.analyticsPageGA4.customPathTipoDocumento,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };
    const paramComplementary = {
      detail: "tipo:tela",
      description: this.analyticsPageGA4.titleError,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();

    if (this.sendAnalyticsFirstView) {
      this.analyticsData();
      this.sendTrackGA4LoadPage();
    }
    this.sendTrackAdjustLoadPage();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  changeItem(event) {
    if (event) {
      this.buttonEnable = true;
    } else {
      this.buttonEnable = false;
    }
  }

  public clickNext() {
    this.sendAnalyticsFirstView = true;
    this.personalDataService.setDocumentTypeNameData(this.selectedName);
    this.personalDataService.setDocumentTypeData(this.selectedItem);
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.documentType,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getPageId(): string {
    return this.headerId;
  }

  async getDomainType() {
    await this.domainFactory
      .getDomainService(this.domainOrigin)
      .getDomains(this.domainDataType)
      .then((dominios) => {
        if (dominios?.length > 0) {
          this.documentType = dominios;
          this.showRetry = false;
          this.analyticsData();
          this.sendTrackGA4LoadPage();
        } else {
          this.showRetry = true;
          this.loading = false;
          this.headerFocus();
          this.sendTrackGA4LoadPageError();
        }
      })
      .catch((err) => {
        this.logService.save(err, "document-type.getDomainType");
        this.showRetry = true;
        this.loading = false;
        this.sendTrackGA4LoadPageError();
      })
      .finally(() => {
        this.loading = false;
        this.headerFocus();
      });
  }

  backPage() {
    this.analyticsEventClique();
    if (this.journeyService.edit) {
      this.personalDataService.setDocumentTypeData(
        this.documetValuesEdit.documentType
      );
      this.personalDataService.setDocumentTypeNameData(
        this.documetValuesEdit.documentTypeName
      );
      this.personalDataService.setDocumentNumber(
        this.documetValuesEdit.documentNumber
      );
      setTimeout(() => {
        this.back();
      }, 80);
    } else {
      if (this.journeyService.journey === TrackTypes.BASIC_PERSONAL_V2) {
        this.router.navigateForward(["data", "client-data"]);
      } else {
        this.back();
      }
    }
  }

  setValueDocumentEdit() {
    setTimeout(() => {
      if (this.journeyService.edit) {
        this.documetValuesEdit = {
          documentType:
            this.journeyService.registratioJourney.data.personalData
              .documentType,
          documentTypeName:
            this.journeyService.registratioJourney.data.personalData
              .documentTypeName,
          documentNumber:
            this.journeyService.registratioJourney.data.personalData
              .documentNumber,
        };
      }
    }, 500);
  }

  setEditPageRegistratio() {
    this.logService.save(
      JSON.stringify(this.journeyService.registratioJourney.data),
      "DocumentTypeComponent.setDataFromJourney"
    );
    if (this.journeyService.registratioJourney.data.personalData.documentType) {
      this.selectedItem =
        this.journeyService.registratioJourney.data.personalData.documentType;
      this.selectedName =
        this.journeyService.registratioJourney.data.personalData.documentTypeName;
      this.buttonEnable = true;
    }
  }
}
